<script>
import titleValueWrapper from "../components/titleValueWrapper";
import auctionTimer from "../components/auctionTimer";
export default {
  name: "requirement-summary",
  components: {
    titleValueWrapper,
    auctionTimer,
  },
  data: function() {
    return {
      requirement: null,
    };
  },
  computed: {
    requirementId: function() {
      return this.$store.state.activeAuction.requirementId;
    },
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },
  async mounted() {
    this.requirement = await this.$store.dispatch("getRequest", { controller: "Requirement", method: `Get/${this.requirementId}` });
  },
};
</script>
<template>
  <div class="row" v-if="requirement">
    <div class="col-4 col-lg-6">
      <title-value-wrapper title="Charterer" :value="requirement.ChartererCompanyName || ''"> </title-value-wrapper>
      <title-value-wrapper title="Vessels" :value="requirement.RequirementVesselsDisplay || ''"> </title-value-wrapper>
    </div>
    <div class="col-8 col-lg-6">
      <title-value-wrapper title="Commencement" :value="requirement.ChartererDetailsCommencement || ''"> </title-value-wrapper>

      <title-value-wrapper title="Period" :value="requirement.PeriodDisplay || ''" :renderAsHtml="true"> </title-value-wrapper>
    </div>
  </div>
</template>
